const {$} = Voonto;

class TermView {
  constructor(container$) {
    this.container$ = container$;
    this.inputAll$  = container$.find('input[data-voc-krammer-term-all-words]');
    this.submit$    = container$.find('button[data-voc-krammer-term-submit]');

    this.bindEvents();
  }

  bindEvents() {
    this.container$.on('submit', this.buildFormAction.bind(this));
  }

  buildFormAction(event) {
    event.preventDefault();
    var all, action, base;

    all = $.trim(this.inputAll$.val());

    action = `${encodeURIComponent(all)}.html`;
    base = this.container$.attr('action') || '';

    document.location.href = `${base}${action}`;
  }
}

export default TermView;



// WEBPACK FOOTER //
// ./src/views/term.js